import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import { addAudit } from "../audits/addAudits";
import {
  Card,
  CardAreaMain,
  CardContent,
  Button,
  CircleProgress
} from "reactackle";
import { isMobile } from "react-device-detect";
import checkBeforeSave from "../../checkBeforeSave/checkBeforeSave";
import getInputField from "../customFields/getInputField";
import {
  actionAddArray2Redux,
  selectARecord,
  notifyUsers,
  setUiFlag
} from "../../../../store/actions";
import moment from "moment";
import terms from "./terms";

class OrderPad extends Component {
  state = {
    data: {
      path: this.props.path,
      payload: {
        ...this.props.selectedRecord
      },
      userEmail: this.props.userProfile.userEmail
    },
    showForm: true,
    allowedFields: [
      "mobile",
      "name",
      "address",
      "specialInstructions",
      "requestedItems"
    ],
    stage: "orderForm"
  };

  componentDidMount() {
    let todaysDate = moment()
      .format("DD-MM-YYYY")
      .toString();
    let targetDate = todaysDate;

    let tgtOrder = {
      name: "",
      address: ""
    };
    if (this.props.createNewRec) {
      if (this.props.orders && this.props.orders.length > 0) {
        let myOrders = this.props.orders.filter(singOrder => {
          //console.log(singOrder.mobile + " vs " + this.props.cellPhone);
          return singOrder.mobile === this.props.cellPhone;
        });
        if (myOrders && myOrders.length > 0) {
          //console.log(JSON.stringify(myOrders));
          tgtOrder = myOrders[myOrders.length - 1];

          this.setState(prevState => {
            return {
              ...prevState,
              data: {
                ...prevState.data,
                payload: {
                  ...prevState.data.payload,
                  name: tgtOrder.name,
                  address: tgtOrder.address,
                  deliveryDate: targetDate
                }
              },
              tgtOrder: tgtOrder
            };
          });
        }
      } else {
        console.log("orders not found");
      }
    } else {
      //console.log("its not even a new rec" + this.props.operationType);
    }
    if (!this.props.cellPhone || this.props.cellPhone === "") {
      const cellPhone = prompt("Please enter your cell phone to continue");

      if (cellPhone && cellPhone !== undefined && cellPhone !== "") {
        this.props.onSetUiFlag("cellPhone", cellPhone);
        //console.log("allOrders length: " + JSON.stringify(this.props.db));

        this.setState(prevState => {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                mobile: cellPhone,
                deliveryDate: targetDate
              }
            },
            proceedForward: true
          };
        });
      } else {
        this.setState(prevState => {
          return {
            ...prevState,
            cellPhone: cellPhone,
            proceedForward: false
          };
        });
      }
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          data: {
            ...prevState.data,
            payload: {
              ...prevState.data.payload,
              mobile: this.props.cellPhone,
              deliveryDate: targetDate
            }
          },
          proceedForward: true
        };
      });
    }
  }

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(
        prevState => {
          if (prevState && prevState.data.payload !== null) {
            return {
              ...prevState,
              data: {
                ...prevState.data,
                payload: {
                  ...prevState.data.payload,
                  ...tmpState
                }
              }
            };
          } else {
            return {
              ...prevState,
              data: {
                path: prevState.data.path,
                payload: {
                  ...tmpState
                }
              }
            };
          }
        },
        () => {
          this.procCalcFields(id);
        }
      );
    } else {
      this.setState(
        prevState => {
          return {
            ...prevState,
            ...tmpState
          };
        },
        () => {
          this.procCalcFields(id);
        }
      );
    }
  };

  procCalcFields = id => {
    //console.log("Checking ID: " + id);
    let allFields = this.props.ogTableDef[this.props.path];
    for (let key in allFields) {
      let fldDef = allFields[key];
      if (fldDef.type === "calculation" && id === fldDef.triggerField) {
        //console.log("id matched: " + id + " " + JSON.stringify(fldDef));
        if (fldDef.calcType === "subFieldsSum") {
          if (fldDef.subFieldOperation === "SUM") {
            this.getSubGridSum(
              fldDef.name,
              fldDef.subGridName,
              fldDef.subGridField
            );
          } else {
          }
        } else if (fldDef.calcType === "mainFieldCalc") {
          this.getCalcdField(fldDef.name, fldDef.formula);
        }
      }
    }
  };

  getValue = (stateVal, operand) => {
    let res = 0.0;
    if (stateVal !== undefined) {
      if (!isNaN(stateVal)) {
        res = parseFloat(stateVal);
      }
    } else {
      if (!isNaN(operand)) {
        res = parseFloat(operand);
      }
    }
    return res;
  };

  getCalcdField = (calcFieldName, calcRules) => {
    //console.log(calcFieldName + " " + JSON.stringify(calcRules));
    let result = 0.0;

    //currently only one rule will work
    let currRule = calcRules[0];
    if (currRule && currRule !== undefined) {
      let val1 = this.getValue(
        this.state.data.payload[currRule.operand1],
        currRule.operand1
      );
      let val2 = this.getValue(
        this.state.data.payload[currRule.operand2],
        currRule.operand2
      );
      let op = currRule.operation;
      if (op && !isNaN(val1) && !isNaN(val2)) {
        if (op === "+") {
          result = val1 + val2;
        } else if (op === "-") {
          result = val1 - val2;
        } else if (op === "*") {
          result = val1 * val2;
        } else if (op === "/") {
          result = val1 / val2;
        }
      }
      // console.log(
      //   "val1:" + val1 + " val2:" + val2 + " op:" + op + " result:" + result
      // );
      if (result !== undefined && !isNaN(result)) {
        this.stateChangeHandler(result.toFixed(2), calcFieldName, true);
      }
    }
  };

  getSubGridSum = (calcFieldName, subGridName, subFieldToProcess) => {
    let items = this.state.data.payload[subGridName];

    if (items && items !== undefined && items.length > 0) {
      let invSum = items.reduce((sum, obj) => {
        //console.log(obj[subFieldToProcess]);
        if (obj[subFieldToProcess] && !isNaN(obj[subFieldToProcess])) {
          return sum + parseFloat(obj[subFieldToProcess]);
        } else {
          return sum;
        }
      }, 0);
      invSum = invSum.toFixed(2);
      this.stateChangeHandler(invSum, calcFieldName, true);
    }
  };

  getField = (fieldName, disabled) => {
    return getInputField(
      fieldName,
      this.props.path,
      this.state.data,
      this.stateChangeHandler,
      disabled,
      this.props.ogTableDef,
      this.props.db
    );
  };

  getFields = () => {
    if (this.props.ogTableDef[this.props.path]) {
      return Object.keys(this.props.ogTableDef[this.props.path]).map(fldKey => {
        if (this.state.allowedFields.includes(fldKey)) {
          return this.getField(fldKey);
        }
      });
    } else {
      console.log("chacha some problems");
    }
  };

  saveHandler = isCancellation => {
    this.stateChangeHandler(this.props.cellPhone, "author", true);
    this.stateChangeHandler([], "supplierPrices", true);
    if (isCancellation) {
      this.stateChangeHandler("CANCELLED", "status", true);
    } else {
      this.stateChangeHandler("WITH GROCER FOR PRICE", "status", true);
    }
    this.stateChangeHandler("ALL", "supplier", true);

    let cloudPath = this.props.path;

    if (
      this.state.data.payload &&
      this.state.data.payload.key &&
      this.state.data.payload.key !== ""
    ) {
      cloudPath = this.props.path + "/" + this.state.data.payload.key;
      Promise.all([
        addAudit(
          this.stateChangeHandler,
          this.props.firebase.auth.currentUser.phoneNumber
        )
      ]).then(res => {
        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            return snap.ref.set(this.state.data.payload);
          })
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => {
            let phArray = [];
            phArray.push(this.state.data.payload.mobile);
            if (isCancellation) {
              this.props.onNotifyUsers(
                "Your order has been cancelled. We would love to see you again. Please Kabir Hossain at 94562455 if you cancelled order due to any problems.",
                phArray
              );
            } else {
              this.stateChangeHandler("showUpdateConfirmation", "stage", false);
              this.props.onNotifyUsers(
                "Your order has been received, we try our best to deliver orders the same day else we deliver next day. We will notify you again once your order gets picked up.",
                phArray
              );
              this.props.onNotifyUsers(
                "New order received. " + this.state.data.payload.requestedItems,
                this.getAllSuppliers()
              );
            }
          });
      });
    } else {
      Promise.all([
        addAudit(
          this.stateChangeHandler,
          this.props.firebase.auth.currentUser.phoneNumber
        )
        //get new ID
      ]).then(res => {
        var newInv = this.props.firebase.db.ref("/" + cloudPath).push();
        newInv
          .set(this.state.data.payload)
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => {
            console.log("added a new record");
            this.stateChangeHandler("showConfirmation", "stage", false);
            let phArray = [];
            phArray.push(this.state.data.payload.mobile);
            this.props.onNotifyUsers(
              "Your order has been received, we try our best to deliver orders the same day else we deliver next day. We will notify you again once your order gets picked up.",
              phArray
            );
            this.props.onNotifyUsers(
              "New order received. " + this.state.data.payload.requestedItems,
              this.getAllSuppliers()
            );
          });
      });
    }
  };

  getAllSuppliers = () => {
    let allSup = _.chain(this.props.users)
      .filter(
        item => item.roleName === "STOREADMIN" || item.roleName === "SUPERADMIN"
      )
      .pluck("userMobile")
      .filter(item => item !== "" && item !== null && typeof item === "string")
      .value();
    allSup.push("94562455");
    allSup.push("97861234");
    return allSup;
  };

  getLoader = () => {
    return (
      <CardContent>
        <CircleProgress indeterminate subtitle="Saving..." />
      </CardContent>
    );
  };

  /*
-webkit-tap-highlight-color: rgba(0,0,0,0);
font-size: 14px;
line-height: 1.42857143;
color: #333;
box-sizing: border-box;
font-family: "RobotMedium";
position: fixed;
top: 60px;
width: 95%;
align-self: center;
z-index: 99999;


-webkit-tap-highlight-color: rgba(0,0,0,0);
font-size: 14px;
line-height: 1.42857143;
color: #333;
box-sizing: border-box;
font-family: "RobotMedium";
z-index: -1;
margin-top: 60px;


  */

  getTopHeader = () => {
    return (
      <table
        className={
          isMobile
            ? "table table-striped table-bordered table-sm"
            : "table table-striped table-bordered table-lg"
        }
      >
        <tbody>
          <tr>
            <td
              style={{
                textAlign: "center",
                padding: "5px"
              }}
            >
              <Button
                text="SUBMIT ORDER"
                onPress={() => this.saveHandler()} //this.getAllSuppliers()}
                colorScheme="primary"
                disabled={
                  !this.state.showForm ||
                  checkBeforeSave(
                    this.props.path,
                    this.state.data.payload,
                    this.props.ogTableDef
                  )
                }
              />
            </td>
            <td
              style={{
                textAlign: "center",
                padding: "5px"
              }}
            >
              <Button
                text="BACK TO MY ORDER LIST"
                onPress={() => this.props.backToList("orderlist")}
                colorScheme="primary"
                disabled={!this.state.showForm}
              />
            </td>
          </tr>
          <tr>
            {this.props.operationType !== "add" && (
              <td
                style={{
                  textAlign: "center",
                  padding: "5px"
                }}
                colSpan={2}
              >
                <Button
                  text="CANCEL THIS ORDER"
                  onPress={e => {
                    if (
                      this.state.data.payload.key &&
                      this.state.data.payload.key !== ""
                    ) {
                      window.confirm(
                        "Are you sure you wish to cancel this order?"
                      ) && this.cancelOder();
                    }
                  }}
                  colorScheme="warning"
                  disabled={!this.state.showForm}
                />
              </td>
            )}
          </tr>
        </tbody>
      </table>
    );
  };

  cancelOder = () => {
    this.saveHandler(true);
    this.stateChangeHandler("showCancellation", "stage", false);
  };

  //f2f4f6

  getOrderForm = () => {
    return (
      <div
        style={{
          WebkitOverflowScrolling: "auto",
          height: "100%"
        }}
      >
        {isMobile && (
          <div style={{ paddingTop: "5px", zIndex: -1 }}>
            <lu>
              <li
                style={{
                  fontSize: "16px",
                  display: "block",
                  backgroundColor: "white",
                  margin: "2px",
                  padding: "5px"
                }}
              >
                <div>Carefully complete below fields.</div>
                <div>Fields marked with * are compulsory.</div>
                <div>Press Submit after filling form.</div>
              </li>
            </lu>

            {/* "mobile",
      "name",
      "address",
      "specialInstructions",
      "requestedItems" */}

            {this.state.showForm &&
              this.state.proceedForward &&
              this.getField("mobile")}
            {this.state.showForm &&
              this.state.proceedForward &&
              this.getField("name")}
            {this.state.showForm &&
              this.state.proceedForward &&
              this.getField("address")}
            {this.state.showForm &&
              this.state.proceedForward &&
              this.getField("specialInstructions")}

            {this.state.showForm && this.state.proceedForward && (
              <div
                style={{
                  marginLeft: "0px",
                  textAlign: "center",
                  marginBottom: "-10px",
                  marginTop: "10px"
                }}
              >
                <Button
                  colorScheme="flat"
                  onPress={() => {
                    //this.props.onSetUiFlag("dataUploadButton", true);
                    //this.perfDelayUpdates();
                    if (
                      this.state.tgtOrder &&
                      this.state.tgtOrder !== undefined &&
                      this.state.tgtOrder.requestedItems &&
                      this.state.tgtOrder.requestedItems !== ""
                    ) {
                      this.setState(prevState => {
                        return {
                          ...prevState,
                          data: {
                            ...prevState.data,
                            payload: {
                              ...prevState.data.payload,
                              requestedItems: prevState.tgtOrder.requestedItems
                            }
                          }
                        };
                      });
                    }
                  }}
                  text={"Copy from Previous Order"}
                  disabled={false}
                />
              </div>
            )}

            {this.state.showForm &&
              this.state.proceedForward &&
              this.getField("requestedItems")}

            {!this.state.proceedForward && (
              <h1>YOUR CELL NUMBER IS REQUIRED TO PROCEED</h1>
            )}
            {!this.state.showForm && this.getLoader()}
            {terms()}
          </div>
        )}
        {!isMobile && (
          <div>
            <Card>
              <CardAreaMain>
                <CardContent style={{ pading: "0px" }}>
                  <div style={{ fontSize: "15px", color: "grey" }}>
                    Carefully complete below fields and tap on SUBMIT button.
                    Fields marked with * are compulsory.
                  </div>
                  {this.state.showForm &&
                    this.state.proceedForward &&
                    this.getFields()}
                  {!this.state.showForm && this.getLoader()}
                  {terms()}
                </CardContent>
              </CardAreaMain>
            </Card>
          </div>
        )}
      </div>
    );
  };

  getOrderConformation = () => {
    window.scroll(0, 0);
    return (
      <div
        style={{
          fontSize: "15px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "20px"
        }}
      >
        <div>You order is successfuly submitted</div>
        <div
          style={{
            marginTop: "10px"
          }}
        >
          <Button
            text="VIEW YOUR ORDERS"
            onPress={() => this.props.backToList("orderlist")}
            colorScheme="primary"
            disabled={!this.state.showForm}
          />
          {terms()}
        </div>
      </div>
    );
  };

  getOrderUpdateConfirmation = () => {
    window.scroll(0, 0);
    return (
      <div
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "20px"
        }}
      >
        <div>You order is successfuly updated and submitted</div>
        <div
          style={{
            marginTop: "10px"
          }}
        >
          <Button
            text="VIEW YOUR ORDERS"
            onPress={() => this.props.backToList("orderlist")}
            colorScheme="primary"
            disabled={!this.state.showForm}
          />
          {terms()}
        </div>
      </div>
    );
  };

  getOrderCancellation = () => {
    window.scroll(0, 0);
    return (
      <div
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "20px"
        }}
      >
        <div>You order has been CANCELLED</div>
        <div
          style={{
            marginTop: "10px"
          }}
        >
          <Button
            text="VIEW YOUR ORDERS"
            onPress={() => this.props.backToList("orderlist")}
            colorScheme="primary"
            disabled={!this.state.showForm}
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.state.stage === "orderForm" && <div>{this.getTopHeader()}</div>}
        {this.state.stage === "orderForm" && this.getOrderForm()}
        {this.state.stage === "showConfirmation" && this.getOrderConformation()}
        {this.state.stage === "showUpdateConfirmation" &&
          this.getOrderUpdateConfirmation()}
        {this.state.stage === "showCancellation" && this.getOrderCancellation()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEmail: state.db.currentUser.userEmail,
    currUser: state.db.currentUser,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    isAdmin: state.ui.isThisAdmin,
    userProfile: state.db.userProfile,
    selectedRecord: state.db["selected" + state.ui.tableName],
    db: state.db,
    createNewRec: state.ui.operationType === "add",
    operationType: state.ui.operationType,
    orders: state.db.deliveryRequest,
    users: state.db.users
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAddRecord: data => dispatch(actionAddArray2Redux(data)),
    onSelectRecord: params => dispatch(selectARecord(params)),
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal)),
    onNotifyUsers: (msgBody, arrayOfUsers) =>
      dispatch(notifyUsers(msgBody, arrayOfUsers))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(OrderPad);



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/OrderPad.jsx